module.exports = __webpack_public_path__ + "60f651e14d81321430ffafec2dc65392.svg";